import { NavBar } from 'components/NavBar/NavBar'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { clearFoodCompanySettings, getFoodCompanySettings } from 'features/food/foodSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { FoodCompanySettingsModal, IFoodCompanySettingsModalState } from './FoodCompanySettingsModal'

export const FoodCompanySettings = () => {

    const [modal, setModal] = useState<{ open: boolean, value: IFoodCompanySettingsModalState }>({ open: false, value: null })
    const { companySettings } = useSelector((store: RootState) => store.food)
    useQueryPagination({ fetchFunctions: [getFoodCompanySettings], cleanUpFunctions: [clearFoodCompanySettings], params: null })

    const handleOpenModal = () => {
        setModal({
            open: true, value: {
                maxMealsPerOperationalDay: companySettings.maxMealsPerOperationalDay || 0,
                mealTypePriorities: companySettings.mealTypePriorities?.length ? companySettings.mealTypePriorities?.map((mtp, i) => ({ id: new Date().getTime() + i, mealType: { label: mtp.mealType.name, value: mtp.mealType.id }, priority: mtp.priority })) : [{ mealType: null, priority: 1, id: new Date().getTime() }]
            }
        })
    }

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Food Company Settings' />
                <Button variant='primary' onClick={handleOpenModal} >Edit Settings</Button>
            </Flex>
            <TextDisplayCard width='300px' title={companySettings?.maxMealsPerOperationalDay} labelText='Maximum amount of meals per day' />
            <Flex column gap='0.5rem' mt='16' >
                {companySettings?.mealTypePriorities?.map((mtp) => (
                    <TextDisplayCard key={mtp.mealType.id} width='300px' title={`${mtp.mealType.name} - Priority: ${mtp.priority}`} labelText='Meal Type Priorities' />
                ))}
            </Flex>
            {modal.open && <FoodCompanySettingsModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />}
        </PageWrapper>
    </>
}